
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as _400XbHBXzo5HyI3Nkb8Jo578Wr3Uf2WHY08T0KFVs_45BZzYMeta } from "/codebuild/output/src1692386816/src/melembre-landing-page-v2/pages/400.vue?macro=true";
import { default as _500FExs_f_4kwaFbK_ofZnrbHCJyj2eKIErnMVmq8ShiLgMeta } from "/codebuild/output/src1692386816/src/melembre-landing-page-v2/pages/500.vue?macro=true";
import { default as infoJaGfqfwm5Y_b5YrjQP3nsiKkMfDw5_45h9fcBwQvyTx24Meta } from "/codebuild/output/src1692386816/src/melembre-landing-page-v2/pages/info.vue?macro=true";
import { default as indexsoYYHqPSvTuwvu8NK6BQco_450NjZkZ8l2TN1kraxnSLQMeta } from "/codebuild/output/src1692386816/src/melembre-landing-page-v2/pages/index.vue?macro=true";
import { default as contato9UyLRGaxf_F8nW57YcXKsDV3XxveWBYIbstBEjYjA6cMeta } from "/codebuild/output/src1692386816/src/melembre-landing-page-v2/pages/contato.vue?macro=true";
import { default as empresaPjiqLITyQxX2ZeUWm4aWfJE4g_xyADdGp9N1VdjO4MAMeta } from "/codebuild/output/src1692386816/src/melembre-landing-page-v2/pages/empresa.vue?macro=true";
import { default as digioE_45OQc5_si3iwJG4mLeGQpAOtycEVu7y3dB7gRxzEOpsMeta } from "/codebuild/output/src1692386816/src/melembre-landing-page-v2/pages/credor/digio.vue?macro=true";
import { default as redirecionarlEgZkJuSSfykJkp204is8yoelJp7Chckx_45pxkvCc8GQMeta } from "/codebuild/output/src1692386816/src/melembre-landing-page-v2/pages/redirecionar.vue?macro=true";
import { default as pontofrioowOKFY2FnMAbcJ9lMFHnd7PPHdXsdG7GJFFQB9C_45Vu4Meta } from "/codebuild/output/src1692386816/src/melembre-landing-page-v2/pages/credor/pontofrio.vue?macro=true";
import { default as casas_45bahiaB4qHnpeffCk7608HO5Bt8lGmKxI8fPE71RMeAC3FM7gMeta } from "/codebuild/output/src1692386816/src/melembre-landing-page-v2/pages/credor/casas-bahia.vue?macro=true";
export default [
  {
    name: "400",
    path: "/400",
    component: () => import("/codebuild/output/src1692386816/src/melembre-landing-page-v2/pages/400.vue")
  },
  {
    name: "500",
    path: "/500",
    component: () => import("/codebuild/output/src1692386816/src/melembre-landing-page-v2/pages/500.vue")
  },
  {
    name: "info",
    path: "/info",
    component: () => import("/codebuild/output/src1692386816/src/melembre-landing-page-v2/pages/info.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexsoYYHqPSvTuwvu8NK6BQco_450NjZkZ8l2TN1kraxnSLQMeta || {},
    component: () => import("/codebuild/output/src1692386816/src/melembre-landing-page-v2/pages/index.vue")
  },
  {
    name: "contato",
    path: "/contato",
    component: () => import("/codebuild/output/src1692386816/src/melembre-landing-page-v2/pages/contato.vue")
  },
  {
    name: "empresa",
    path: "/empresa",
    component: () => import("/codebuild/output/src1692386816/src/melembre-landing-page-v2/pages/empresa.vue")
  },
  {
    name: "credor-digio",
    path: "/credor/digio",
    meta: digioE_45OQc5_si3iwJG4mLeGQpAOtycEVu7y3dB7gRxzEOpsMeta || {},
    component: () => import("/codebuild/output/src1692386816/src/melembre-landing-page-v2/pages/credor/digio.vue")
  },
  {
    name: "redirecionar",
    path: "/redirecionar",
    component: () => import("/codebuild/output/src1692386816/src/melembre-landing-page-v2/pages/redirecionar.vue")
  },
  {
    name: "credor-pontofrio",
    path: "/credor/pontofrio",
    meta: pontofrioowOKFY2FnMAbcJ9lMFHnd7PPHdXsdG7GJFFQB9C_45Vu4Meta || {},
    component: () => import("/codebuild/output/src1692386816/src/melembre-landing-page-v2/pages/credor/pontofrio.vue")
  },
  {
    name: "credor-casas-bahia",
    path: "/credor/casas-bahia",
    meta: casas_45bahiaB4qHnpeffCk7608HO5Bt8lGmKxI8fPE71RMeAC3FM7gMeta || {},
    component: () => import("/codebuild/output/src1692386816/src/melembre-landing-page-v2/pages/credor/casas-bahia.vue")
  }
]